export default __webpack_public_path__ + "static/realWorldImage5-4c7e92f68413dfc2d917eaf8d12bdf06.webp";